import React from 'react';
import Search from './search/search';

const Home = () => {
    return (
        <div>
            <Search />
        </div>
    )
}

export default Home